<template>
  <div class="container">
   
    <tabs @changed="update_dataV" :options="{ useUrlFragment: false }" ref="tabs_dom">
        <tab name="贝叶斯原理" hash="BayesTheory">
            <!-- <div><img :src="bayes_theory_pic"></div> -->
            <bayes-theory></bayes-theory>
        </tab>
        <tab name="贝叶斯计算器" hash="BayesCaculator">
            <div class="row" v-show="load_done">
                <left-side-bar v-show="show_panel"></left-side-bar>
                <bayes-caculator @toggle_panel="show_panel=!show_panel" ref="calc_dom"> </bayes-caculator>
            </div>
            <bayes-case v-show="show_case" style="position:absolute;inset:0px;" ref="case_dom" @select_case="select_case"></bayes-case>
        </tab>
        <tab name="贝叶斯分类器" hash="BayesClassfier">
            <bayes-classifier></bayes-classifier>
        </tab>
        <!-- <tab name="帮助 Ⓗ">
          '等待添加'
          
        </tab> -->
        <template #header>
            <li class="tabs-component-tab">
                <a class="tabs-component-tab-a" @click="show_help">
                    帮助 Ⓗ
                </a>
            </li>
            <li class="tabs-component-tab" v-if="tab_name=='贝叶斯计算器' && !show_case">
                <a class="tabs-component-tab-a" @click="page_return">
                    返回 ↶
                </a>
            </li>
        </template>
    </tabs>

    <!-- <dv-loading v-show="load_done">Loading...</dv-loading> -->
    <div :class="'overlayer-guide ' + (model?'model':'')" v-if="show_guide">
        <bayes-case-guide 
            v-if="tab_name=='贝叶斯计算器' && show_case " 
            @chg_idx="guide_idx" 
            @skip="skip_guide" 
            @guide_over="guide_over"
        ></bayes-case-guide>
        <caculator-guide v-if="tab_name=='贝叶斯计算器' && !show_case " @chg_idx="guide_idx" @skip="skip_guide" @guide_over="guide_over"></caculator-guide>


    </div>
    

  </div>
</template>

<script>
import "~css/global.styl";
import {msgbox} from "~pjs/msgbox.esm.js";
import {create_dom_except_cover_img} from "~pjs/xfl_tool.esm.js";
import LeftSideBar from "./components/LeftSideBar.vue";
import BayesCaculator from "./components/BayesCaculator.vue";
import BayesClassifier from "./components/BayesClassifier.vue";
import BayesCase from "./components/BayesCase.vue";

import BayesCaseGuide from "./components/overlay_guide/BayesCaseGuide.vue";
import CaculatorGuide from "./components/overlay_guide/CaculatorGuide.vue";


// import MainHeader from "./components/MainHeader.vue";
// import MainTodo from "./components/MainTodo/MainTodo.vue";

import bayyes_theory_pic from "~pic/bayes_theory.png"
import BayesTheory from './components/BayesTheory.vue';

export default {
  name: "App",
  components: {
    //组件名:组件对象
      LeftSideBar,
      BayesCaculator,
      BayesClassifier,
      BayesTheory,
      BayesCase,
      BayesCaseGuide,
      CaculatorGuide,
  },
  data() {
    return {
      bayes_theory_pic:bayyes_theory_pic,
      tab_name:'', //记录tab标签页的名称
      load_done:false,
      show_panel:false,
      list: ["todo 1", "todo 2"],
      new_list: "",
      model:true,
      show_guide:false,
      show_case:true,
      calc_guide_times:0,
      case_guide_times:0,
    };
  },
  mounted() {
    this.load_done = true;
    console.log('app mounted');
    const that = this;
    setTimeout(()=>{
        that.$refs.tabs_dom.selectTab('#贝叶斯计算器');
        //that.show_help();

        setTimeout(()=>{

            //that.set_mask('.tabs-component-tab.is-active',2);
            //that.guide_idx(0);//初次调用一下
        },10)
      

    },100);
  },
  methods: {
    skip_guide(name){
        console.log('skip guide',name);
        this.show_guide = false;
    },
    set_mask(sub_dom,expand=1){
        const mask = document.querySelector('.overlayer-guide');
        const image = create_dom_except_cover_img(mask,sub_dom,undefined,undefined,expand);
        mask.style.backgroundImage =`url(${image.src})`;
    },
    select_case(name){
        console.log('select case',name);
        this.show_guide = false;
        this.show_case = false;
        this.auto_help();
        this.$refs.calc_dom.event_info.sample_name = name;
    },
    case_guide_deal(idx){
        if(idx==3){
            this.model = false;
            this.$refs.case_dom.list.forEach(v=>v.disabled = true);
            this.$refs.case_dom.list[0].disabled = false;
            this.$refs.case_dom.list[0].active = true;
            this.set_mask('.card-container .card');
            this.case_guide_times ++; //当前已经引导次数加1
        }else{
            this.model = true;
            this.$refs.case_dom.list.forEach(v=>{
                v.disabled = false;
                v.active = false;
            });
            this.set_mask();
        }
    },
    calc_guide_deal(idx){
        console.log('calc_guide_deal',idx);
        if(idx<=2){//左侧按钮透过
            this.set_mask(`.quick_panel2 button:nth-child(${idx+1})`);
        }else if(idx==3){//问题帮助按钮透过
            this.set_mask(Array.from(document.querySelectorAll('.two-column .help-class')));
        }else if(idx==4){//计算图形按钮透过
            const sub_dom = Array.from(document.querySelectorAll('.item_btn'));
            sub_dom.push(document.querySelector('.btn_calc_a'));
            this.set_mask(sub_dom);
        }
    },
    guide_idx(idx){
        console.log('App recived idx',idx);
        //在最后一张时，取消屏蔽层 图片移到右下
        if(this.tab_name=='贝叶斯计算器'){
            if(this.show_case){ //案例引导的特殊处理
                this.case_guide_deal(idx)
            }else{
                this.calc_guide_deal(idx)
            }
        }
    },
    guide_over(name){
        if(name=='CaculatorGuide'){
            this.calc_guide_times++;
            //重新跳到案例引导界面？
            if(this.calc_guide_times==1){
                this.show_case = true;
                this.$refs.case_dom.list.forEach(v=>v.disabled = v.active = false);
                this.show_guide = this.case_guide_times == 0;//
            }else{
                this.show_guide = false;
            }
        }else if(name == 'BayesCaseGuide'){
            this.case_guide_times++;
            // if(this.case_guide_times==0){
            //     this.show_case = true;
            // }
        }
    },
    update_dataV(v){
      console.log('update DataV',v);
      const cur_dom = document.querySelector(".speaker-box video");
      this.tab_name = v.tab.name;
      setTimeout(()=>window.dispatchEvent(new Event('resize')),3);
      this.auto_help();
    },
    show_help(){
        console.log('show_help');
        this.show_guide = !this.show_guide;
        const that = this;
        if(this.show_guide){
            if(['贝叶斯计算器'].includes(this.tab_name)){
                setTimeout(() => {
                    that.guide_idx(0);//第一张处理背景遮罩    
                }, 50);
            }else{
                this.show_guide = false;
                msgbox({
                    type:'pop',
                    title:'',
                    msg:'<p style="font-size:18px;">该栏目当前没有帮助，谢谢!</p>',
                    show_time:1000,
                })
            }

        }
    },
    auto_help(){//智能判断是否显示帮助

        if(this.tab_name == '贝叶斯计算器'){
            if(this.show_case && this.case_guide_times==0){
                this.show_guide = this.show_case = true;
            }else if(!this.show_case && this.calc_guide_times == 0){
                this.show_guide = true;
                this.show_case = false;
            }
        };

        //刷新遮盖
        const that = this;
        if(this.show_guide){
            this.model = true;
            setTimeout(() => {
                that.guide_idx(0);//第一张处理背景遮罩    
            }, 50);
        }
    },
    page_return(){
        console.log('page return');
        this.show_case = true;
        this.$refs.case_dom.list.forEach(v=>v.disabled = v.active = false);
        this.auto_help();
    }
  },
  created() {
    // console.log(img);
  },
};
// console1.log('yes');
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/var.styl';
.container
  //padding-top:30px;
  display:block
  width:100%
  height:100%
  max-width:1171px
  margin:0 auto;
  background-color:$container_color;
  //top:30px;
  font-family: cursive;
  
  background:url('~pic/bayes-bg.png') no-repeat 100% 100% cover;
  position:relative;

.width_0
  width:0px;
  

.row
  display:flex

.overlayer-guide
    position:absolute;
    inset:0;
    z-index:2;
    padding-top:5em;
    pointer-events:none;

.overlayer-guide.model
    //background-color:rgba(1, 1, 1, 0.5);
    pointer-events:auto;
    //clip-path: inset(50px 50px 50px 50px);
    //-webkit-mask-image: linear-gradient(transparent, transparent 50px, black 50px, black calc(100% - 50px), transparent calc(100% - 50px)); 
    //-webkit-mask-image:url(#mask);
    //background-image:url('~pic/mask.png');

.overlayer-guide *
    pointer-events:auto;

</style>
